import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { customStylesModal } from "./ConfirmModal";
import { useStream } from "../hooks/useStream";
import { useCalls, CallingState } from "@stream-io/video-react-sdk";
import { useRouter } from "../hooks/useRouter";
import { useAuth } from "../hooks/useAuth";

const DialogCallingCall = () => {
    const { leaveCall, onJoinCall, idsCallsIgnored, addIdsCallsIgnored } = useStream();
    const calls = useCalls();
    const { navigateToCall } = useRouter();
    const { currentUserId } = useAuth();

    const outgoingCalls = calls.filter(
        (call) =>
          call.isCreatedByMe === true &&
          call.state.callingState === CallingState.RINGING,
      );
    const [outgoingCall] = outgoingCalls;

    useEffect(() => {
        const handleCallAccepted = () => {
            onJoinCall(currentUserId ?? '', outgoingCall);
            navigateToCall();
        }

        if(outgoingCall) {
            outgoingCall.on('call.accepted', handleCallAccepted);
        }

        return () => {
            outgoingCall?.off('call.accepted', handleCallAccepted);
        }
    }, [outgoingCall]);

    const calledUser = outgoingCall?.state?.members.find((member) => member.user.id !== outgoingCall?.state?.createdBy?.id);

    const image = calledUser?.user?.image;
    const name = calledUser?.user?.name;
    const isOpen = outgoingCall !== undefined && !idsCallsIgnored.includes(outgoingCall?.id);

    const onClose = () => {
        addIdsCallsIgnored(outgoingCall?.id);
    }

    const onDecline = () => {
        leaveCall()
    }

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} style={customStylesModal('440px')}>
            <div className="p-4 flex flex-col gap-12 items-center justify-center">
                <div className="flex flex-col gap-4 items-center justify-center pt-4">
                    <div className="w-[200px] h-[200px] rounded-full overflow-hidden">
                        <img src={image} className="w-full h-full object-cover" />
                    </div>
                    <h1 className="text-3xl font-semibold">Calling {name}...</h1>
                </div>
                <div className="flex flex-row gap-16 justify-center items-center">
                    <div className="flex flex-col items-center justify-center gap-2">
                        <button onClick={onDecline} className="bg-red-500 text-white rounded-full w-[70px] h-[70px] flex items-center justify-center hover:bg-red-600">
                            <span className="material-symbols-outlined text-3xl">
                                close
                            </span>
                        </button>
                        <p className="text-md">Cancel</p>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default DialogCallingCall;